import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import useLoadingAdditionalInformation from 'hooks/Shared/useLoadingAdditionalInformation'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { downloadFileFromData } from 'lib/helpers/utilities'
import { QueryOptions } from 'models/general'
import {IInvoice,  CreditNote, CreditNoteFiles } from 'models/invoices.models'
import { getCreditNoteFiles } from 'services/Invoices/invoices.services'

const useDownloadCreditNoteFiles = (
  workspaceId: number,
  invoice?: IInvoice,
  creditNote?: CreditNote,
  options: QueryOptions<CreditNoteFiles> = {}
) => {
  const { onSuccess, onError, noDialog } = options

  const dialog = useDialog()
  const showAdditionalLoading = useLoadingAdditionalInformation()

  const query = useQuery<CreditNoteFiles>(
    [
      'get-payment-complement-files-in-base64',
      workspaceId,
      invoice,
      creditNote,
    ],
    () => {
      if (!invoice || !invoice.idCfdi) throw new Error('CFDI cargado incorrectamente')
      if (!creditNote)
        throw new Error('Nota de crédito cargada incorrectamente')
      showAdditionalLoading()
      return getCreditNoteFiles(
        workspaceId,
        invoice.idCfdi,
        creditNote.idCreditNote
      )
    },
    {
      enabled: false,
      onSuccess: files => {
        dialog.close()
        onSuccess && onSuccess(files)
        downloadFileFromData(`${creditNote?.uuid || 'PDF'}.pdf`, files.pdf)
        downloadFileFromData(`${creditNote?.uuid || 'XML'}.xml`, files.xml)
      },
      onError: async (error: any) => {
        setTimeout(async () => {
          const op = selectErrorDialog(error)

          if (op?.variant) {
            await dialog[op.variant](op)
            return
          }

          if (!noDialog) {
            const rp = await dialog.dangerAsync({
              title: 'generic.error.title',
              subtitle: 'No se pudo descargar la nota de credito seleccionada.',
              icon: ErrorOutline as TModalIcon,
              primaryButtonText: 'Reintentar',
              secondaryButtonText: 'Cancelar',
            })

            if (rp) {
              query.refetch()
              return
            }
          }

          onError && onError(error)
        }, 600)
      },
    }
  )

  return query
}

export default useDownloadCreditNoteFiles
